import { Modal } from "@aqar-app/react-ui";
import { useAuthState } from "../../../../contexts/auth/auth.provider";
import useToggleFav from "../../../../hooks/useToggleFav";
import LoginAlert from "../../../login-alert";
import { Icon } from "@/components/icon";
import {
  listingToEECItemObject,
  trackAddToWishlist,
} from "@/lib/tracking/trackEECEvents";
import { usePath } from "@/contexts/path/path";

function FavButton({ listing, ...props }) {
  const { token } = useAuthState();
  const { isFaved, toggleFavMutation } = useToggleFav(listing?.id);
  const { categoriesDictionary } = usePath();

  const handleAddFavClick = (e) => {
    if (!token) {
      Modal.open(
        <LoginAlert text="يرجى تسجيل الدخول لإضافة الإعلان للمفضلة " />,
      )(e);
    } else {
      e.target.disabled = true;
      toggleFavMutation({ variables: { fav: listing?.id } }).finally(() => {
        e.target.disabled = false;
      });
      trackAddToWishlist(
        listingToEECItemObject(listing, undefined, categoriesDictionary),
        { value: listing.price },
      );
    }
  };

  return (
    <button type="button" {...props} onClick={handleAddFavClick}>
      <Icon
        width={20}
        height={20}
        name={isFaved ? "Hearted-colored" : "Heart"}
      />
      حفظ
    </button>
  );
}

export default FavButton;
